import React, { useEffect } from 'react';
import StatCard from '../../components/StatCard';
import { useAppDispatch, useAppSelector } from '../../hooks/storeHooks';
import { getAllAdmins } from '../../store/slice/partnersSlice';
import { getAllModules } from '../../store/slice/moduleSlice';
import { getAllPresets } from '../../store/slice/presetSlice';
import { getLoadingState } from '../../utils/Helper/helper';

const BtAdminPanel: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const presetState = useAppSelector((state) => state.presets);
  const partnerState = useAppSelector((state) => state.partners);
  const moduleState = useAppSelector((state) => state.modules);
  const partnerList = partnerState.data ?? [];
  const presets = presetState.data ?? [];
  const modules = moduleState.data ?? [];
  const isLoadingModules = getLoadingState(moduleState);
  const isLoadingPartners = getLoadingState(partnerState);
  const isLoadingPresets = getLoadingState(presetState);

  const systemModules = modules.filter((module) => module?.isSystemModule);
  const baseModules = modules.filter((module) => !module?.isSystemModule);

  useEffect(() => {
    if (partnerState.status !== 'loading') {
      void dispatch(getAllAdmins());
    }
    if (moduleState.status !== 'loading') {
      void dispatch(getAllModules());
    }
    if (presetState.status !== 'loading') {
      void dispatch(getAllPresets());
    }
  }, []);

  return (
    <div className="max-w-full overflow-hidden overflow-x-scroll">
      <div className="max-w-full h-fit py-4 px-4 flex flex-wrap flex-col md:flex-row justify-center md:justify-start gap-4">
        <StatCard
          className="w-full md:w-40 h-32 md:h-40 lg:h-56 lg:w-56 aspect-square"
          title="Partners"
          value={partnerList.length}
          isLoading={isLoadingPartners}
        />
        <StatCard
          className="w-full md:w-40 h-32 md:h-40 lg:h-56 lg:w-56 aspect-square"
          title="Total Modules"
          value={modules.length}
          isLoading={isLoadingModules}
        />
        <StatCard
          className="w-full md:w-40 h-32 md:h-40 lg:h-56 lg:w-56 aspect-square"
          title="Base Modules"
          value={baseModules.length}
          isLoading={isLoadingModules}
        />
        <StatCard
          className="w-full md:w-40 h-32 md:h-40 lg:h-56 lg:w-56 aspect-square"
          title="System Modules"
          value={systemModules.length}
          isLoading={isLoadingModules}
        />
        <StatCard
          className="w-full md:w-40 h-32 md:h-40 lg:h-56 lg:w-56 aspect-square"
          title="Presets"
          value={presets.length}
          isLoading={isLoadingPresets}
        />
      </div>
    </div>
  );
};
export default BtAdminPanel;
